module.exports = __webpack_public_path__ + "img/sales.ae24d3b1.svg";